import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { Card, Spinner, Col, Row, Form } from 'react-bootstrap';
import TotalAnualByMonthChart from './TotalAnualByMonthChart';

import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import holdTicket from 'assets/img/support-desk/hold-tickets.png';


const TotalAnualByMonth = () => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);

    const [chartData, setChartData] = useState({
        monthNames: [],
        monthSales: [],
        totalAnualSales: 0
    });
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    useEffect(() => {
        obtenerVentasTotalesAnuales();
    }, [selectedYear]);

    /**
     * Obtiene las ventas totales anuales por mes
     */
    const obtenerVentasTotalesAnuales = async () => {
        setCargando(true);

        const response = await fetch("/api/Administradores/ventasTotalesAnuales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Year: selectedYear
                })
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response?.ok) {
            const responseType = await response.json();
            console.log("===== CHART DATA ANUAL SALES =====");

            if (responseType.iResponseType === 1) {
                const data = JSON.parse(responseType.detalles);

                var salesByMonth = data[0];
                var totalAnualSales = data[1][0];

                // Si es el año actual, filtrar solo hasta el mes actual
                if (selectedYear === new Date().getFullYear()) {
                    const currentMonth = new Date().getMonth() + 1;
                    salesByMonth = salesByMonth.filter(month => {
                        const monthNumber = month.TheYearMonth.split('-')[1];
                        return parseInt(monthNumber) <= currentMonth;
                    });

                    // Recalcular el total anual con los meses filtrados
                    totalAnualSales.totalMXN = salesByMonth.reduce((sum, month) => sum + month.totalMXN, 0);
                }

                var monthNames = [];
                var monthSales = [];
                var i = 0;
                salesByMonth.forEach((month) => {
                    monthNames[i] = month.TheMonthNameYear;
                    monthSales[i] = month.totalMXN;
                    i++;
                });

                var chartData_ = [];
                chartData_.monthNames = monthNames;
                chartData_.monthSales = monthSales;
                chartData_.totalAnualSales = totalAnualSales.totalMXN;

                setChartData(chartData_);


                //console.log(monthNames);
                //setMonthNameYear(monthNames);
                //setSalesByMonth(monthSales);
                //setAnualSales(totalAnualSales.totalMXN);

                setCargando(false);


            } else {
                showErrorToast(responseType.vMessage);
            }

        }
        else {
            showErrorToast(response?.status + ' ' + response?.statusText);

            if (response?.status === 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }

        setCargando(false);
    }

    // Generar array de años desde 2020 hasta el año actual
    const years = Array.from(
        { length: new Date().getFullYear() - 2019 },
        (_, i) => 2020 + i
    ).reverse();

    const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control
                size="sm"
                ref={ref}
                onClick={onClick}
                value={value}
                className="ps-4"
                onChange={e => {
                    console.log({ e });
                }}
            />
            <FontAwesomeIcon
                icon="calendar-alt"
                className="text-primary position-absolute top-50 translate-middle-y ms-2"
            />
        </div>
    ));
    GreetingsDateInput.propTypes = {
        value: PropTypes.string,
        onClick: PropTypes.func
    };

    return (
        <>
            {
                cargando ?
                    <>
                        <Card >
                            <Card.Header>
                                <Row>
                                    <Col>
                                        <h5><Spinner className='text-inline mt-3 ms-2' animation='border' variant='primary' /> Cargando... Ventas Anuales por mes </h5>
                                    </Col>
                                </Row>


                            </Card.Header>

                        </Card>
                        <Skeleton height={400} style={{ "zIndex": "-1" }} />
                    </>
                    :
                    <>
                        <Row>

                            <Col className="col-12">

                                <Card>
                                    <Card.Header>
                                        <Row className="flex-between-center g-0">
                                            <Col xs="auto">
                                                <h6 className="mb-0">Ventas Anuales por mes</h6>
                                            </Col>
                                            <Col xs="auto">
                                                <Form.Select
                                                    size="sm"
                                                    value={selectedYear}
                                                    onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                                                    style={{ width: '120px' }}
                                                >
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body className="pe-xxl-0">
                                        <Row className="p-1">

                                            <Col className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 m-0">
                                                <img src={holdTicket} alt="" width="39" className="mt-1 mb-2" />
                                                <div className="text-700 fs--2">
                                                    <strong>TOTAL </strong>(IVA incluido)
                                                </div>
                                                <h5 className="mt-0 mb-0 text-black fw-normal">
                                                    {(chartData?.totalAnualSales || 0).toLocaleString('es-MX', {
                                                        style: 'currency',
                                                        currency: 'MXN'
                                                    })}
                                                </h5>
                                                <div className="text-700 fs--2">
                                                    IVA{' '}
                                                    <strong>
                                                        {((chartData?.totalAnualSales || 0) -
                                                            (chartData?.totalAnualSales || 0) / 1.16).toLocaleString('es-MX', {
                                                                style: 'currency',
                                                                currency: 'MXN'
                                                            })}
                                                    </strong>
                                                </div>
                                            </Col>
                                            <Col className="col-xxl-10 col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6 ">
                                                <TotalAnualByMonthChart data_={chartData || { monthNames: [], monthSales: [], totalAnualSales: 0 }} />
                                            </Col>

                                        </Row>

                                    </Card.Body>
                                </Card>

                            </Col>
                        </Row>

                    </>
            }
        </>

    );
};

export default TotalAnualByMonth;
